import CoreUtils from "./CoreUtils";

export default class DomUtils {
  static getElementItemByClassName(className) {
    var elements = document.getElementsByClassName(className);
    if (elements.length === 0)
      return null;

    return elements[0];
  }

  static getElementItemByClassNames(className1, className2) {
    var elements = document.getElementsByClassName(className1);
    if (elements.length === 0)
      return null;

    elements = elements[0].getElementsByClassName(className2);
    if (elements.length === 0)
      return null;

    return elements[0];
  }

  static calculateInnerContentSize(element) {
    if (CoreUtils.isUndefinedOrNull(element))
      return {
        width: 0,
        height: 0
      };

    var computedStyle = getComputedStyle(element);

    var contentWidth = element.offsetWidth;
    var contentHeight = element.offsetHeight;

    contentWidth -= DomUtils.parseLengthValue(computedStyle.borderLeftWidth);
    contentWidth -= DomUtils.parseLengthValue(computedStyle.paddingLeft);
    contentWidth -= DomUtils.parseLengthValue(computedStyle.paddingRight);
    contentWidth -= DomUtils.parseLengthValue(computedStyle.borderRightWidth);

    contentHeight -= DomUtils.parseLengthValue(computedStyle.borderTopWidth);
    contentHeight -= DomUtils.parseLengthValue(computedStyle.paddingTop);
    contentHeight -= DomUtils.parseLengthValue(computedStyle.paddingBottom);
    contentHeight -= DomUtils.parseLengthValue(computedStyle.borderBottomWidth);

    return {
      width: contentWidth,
      height: contentHeight
    };
  }

  static calculateInnerContentSizeStyle(element) {
    var size = DomUtils.calculateInnerContentSize(element);
    return {
      width: size.width + "px",
      height: size.height + "px"
    }
  }


  static calculateOuterContentSize(element) {
    if (CoreUtils.isUndefinedOrNull(element))
      return {
        width: 0,
        height: 0
      };

    var computedStyle = getComputedStyle(element);

    var contentWidth = element.offsetWidth;
    var contentHeight = element.offsetHeight;

    contentWidth += DomUtils.parseLengthValue(computedStyle.marginLeft);
    contentWidth += DomUtils.parseLengthValue(computedStyle.marginRight);
    contentHeight += DomUtils.parseLengthValue(computedStyle.marginTop);
    contentHeight += DomUtils.parseLengthValue(computedStyle.marginBottom);

    return {
      width: contentWidth,
      height: contentHeight
    };
  }

  static calculateOuterContentSizeStyle(element) {
    var size = DomUtils.calculateOuterContentSize(element);
    return {
      width: size.width + "px",
      height: size.height + "px"
    }
  }

  static setElementSize(element, size) {
    if (CoreUtils.isUndefinedOrNull(element))
      return;

    element.style.width = size.width + 'px';
    element.style.height = size.height + 'px';
  }

  static setElementHeight(element, height) {
    if (CoreUtils.isUndefinedOrNull(element))
      return;

    element.style.height = height + 'px';
  }

  static setElementMaxHeight(element, height) {
    if (CoreUtils.isUndefinedOrNull(element))
      return;

    element.style.maxHeight = height + 'px';
  }

  static setElementWidth(element, width) {
    if (CoreUtils.isUndefinedOrNull(element))
      return;

    element.style.width = width + 'px';
  }

  static setElementMaxWidth(element, width) {
    if (CoreUtils.isUndefinedOrNull(element))
      return;

    element.style.maxWidth = width + 'px';
  }

  static calculateInnerContentHeight(element) {
    return DomUtils.calculateInnerContentSize(element).height;
  }

  static calculateOuterContentHeight(element) {
    return DomUtils.calculateOuterContentSize(element).height;
  }

  static calculateInnerContentWidth(element) {
    return DomUtils.calculateInnerContentSize(element).width;
  }

  static calculateOuterContentWidth(element) {
    return DomUtils.calculateOuterContentSize(element).width;
  }

  static parseLengthValue(value) {
    if (value === undefined || value === null)
      return 0;

    if (typeof value === 'number')
      return value;

    if (typeof value === 'string' && value.endsWith('px'))
      value = value.slice(0, value.length - 2);

    value = Number(value);

    return !isNaN(value) ? value : 0;
  }

  static replaceClassName(domTokenList, namePrefix, newClassName) {
    if (CoreUtils.isUndefinedOrNull(domTokenList))
      return;

    const iterator = domTokenList.values();

    var oldClassName;
    for (let value of iterator) {
      if (value.startsWith(namePrefix) === true) {
        oldClassName = value;
        break;
      }
    }

    if (oldClassName === undefined || oldClassName === newClassName)
      return;

    domTokenList.replace(oldClassName, newClassName);
  }

  static ensureClassNameExists(domTokenList, className) {
    if (CoreUtils.isUndefinedOrNull(domTokenList))
      return;

    domTokenList.add(className);
  }

  static ensureClassNameRemoved(domTokenList, className) {
    if (CoreUtils.isUndefinedOrNull(domTokenList))
      return;

    domTokenList.remove(className);
  }

  static isElementScrolledIntoView(element, scrollParentElement) {
    var elementRect = element.getBoundingClientRect();
    var scrollParentRect = scrollParentElement.getBoundingClientRect();

    return elementRect.top <= scrollParentRect.bottom && elementRect.bottom >= scrollParentRect.top;
  }
}